(function () {
  'use strict';

  if (window.__BigsmallAiSearchBridge) return;
  window.__BigsmallAiSearchBridge = true;

  var FINDER_PATH = '/pages/ai-gift-finder';

  function finderUrl(query) {
    var value = String(query || '').trim();
    return value ? FINDER_PATH + '?q=' + encodeURIComponent(value) : FINDER_PATH;
  }

  function looksLikeBrief(query) {
    var value = String(query || '').trim();
    return value.length >= 24 || /\b(under|below|budget|qty|quantity|employees?|clients?|without|exclude|diwali|joining|onboarding|premium|sustainable)\b/i.test(value);
  }

  function createBridge(context) {
    var searchPage = context === 'search-page';
    var bridge = document.createElement('div');
    bridge.className = 'bs-ai-search-bridge bs-ai-search-bridge--' + context;
    bridge.setAttribute('data-bs-ai-search-bridge', '');
    bridge.innerHTML =
      '<span class="bs-ai-search-bridge__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 32 32"><path d="M16 3.5l2.3 7.1 7.2 2.3-7.2 2.3-2.3 7.2-2.3-7.2-7.2-2.3 7.2-2.3L16 3.5Z"></path><path d="M24.8 19.4l1.1 3.3 3.3 1.1-3.3 1.1-1.1 3.3-1.1-3.3-3.3-1.1 3.3-1.1 1.1-3.3Z"></path></svg>' +
      '</span>' +
      '<span class="bs-ai-search-bridge__copy">' +
        '<strong>' + (searchPage ? 'Need recommendations instead of an exact product?' : 'Have a complete gifting requirement?') + '</strong>' +
        '<span>Describe budget, quantity, recipient, occasion and exclusions in one sentence.</span>' +
      '</span>' +
      '<a class="bs-ai-search-bridge__link" data-bs-ai-search-link href="' + FINDER_PATH + '">Use AI Gift Finder <span aria-hidden="true">→</span></a>';
    return bridge;
  }

  function bindBridge(bridge, input) {
    if (!bridge || bridge.dataset.bsAiBound === 'true') return;
    bridge.dataset.bsAiBound = 'true';

    var link = bridge.querySelector('[data-bs-ai-search-link]');
    var strong = bridge.querySelector('.bs-ai-search-bridge__copy strong');
    var baseHeading = strong ? strong.textContent : '';

    function sync() {
      var query = input ? input.value : '';
      var isBrief = looksLikeBrief(query);
      if (link) link.href = finderUrl(query);
      bridge.classList.toggle('is-brief', isBrief);
      if (strong) {
        strong.textContent = isBrief
          ? 'This looks like a gifting brief — let the finder rank suitable options'
          : baseHeading;
      }
    }

    if (input) {
      input.addEventListener('input', sync, { passive: true });
      input.addEventListener('change', sync, { passive: true });
    }
    sync();
  }

  function injectHeaderBridge() {
    document.querySelectorAll('.search-modal__content').forEach(function (modal) {
      if (modal.querySelector('.bs-ai-search-bridge--header')) return;

      var predictive = modal.querySelector('predictive-search, search-form');
      var quickLinks = modal.querySelector('.bigsmall-search-quick-links');
      var input = modal.querySelector('input[type="search"]');
      var bridge = createBridge('header');

      if (quickLinks && quickLinks.parentNode) {
        quickLinks.insertAdjacentElement('afterend', bridge);
      } else if (predictive) {
        predictive.appendChild(bridge);
      } else {
        modal.appendChild(bridge);
      }
      bindBridge(bridge, input);
    });
  }

  function injectSearchPageBridge() {
    document.querySelectorAll('.bigsmall-search-page__form-wrap').forEach(function (wrap) {
      if (wrap.querySelector('.bs-ai-search-bridge--search-page')) return;
      var input = wrap.querySelector('input[type="search"]');
      var bridge = createBridge('search-page');
      wrap.appendChild(bridge);
      bindBridge(bridge, input);
    });
  }

  function ensureProductType(form) {
    if (!form) return;
    var input = form.querySelector('input[name="type"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'type';
      form.appendChild(input);
    }
    input.value = 'product';
  }

  function prepareSearchLink(link) {
    if (!link || !link.href) return;
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || url.pathname !== '/search') return;
      url.searchParams.set('type', 'product');
      link.href = url.toString();
    } catch (error) {
      // Ignore malformed URLs and leave Shopify's native link untouched.
    }
  }

  function prepareSearchRouting(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('form[action*="/search"]').forEach(ensureProductType);
    root.querySelectorAll('a[href*="/search?"]').forEach(prepareSearchLink);
  }

  function mount(scope) {
    injectHeaderBridge();
    injectSearchPageBridge();
    prepareSearchRouting(scope || document);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    ensureProductType(form);
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/search?"]');
    if (link) prepareSearchLink(link);
  }, true);

  function boot() {
    mount(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    mount(event.target || document);
  });
})();
